import { formatCurrency } from '@chikara/utils';
import type { TeamMember } from '../types/team.types';
import { ROLES, TeamMemberStatus } from '../constants/team.constants';
import { useAuthContext } from '@/features/auth/context/AuthContext';
import { isBasic } from '@/shared/config/permissions';


export const formatMXN = (value: number) =>
  formatCurrency(value, { locale: 'es-MX', currency: 'MXN' });


export const formatTableData = (members: TeamMember[]) => {
  const { payload: authPayload } = useAuthContext();

  return members.map((m) => {
    const rawStatus = String(m.status).toLowerCase();
    const sameUser = authPayload?.user_uuid === m.uuid;
    const basic = isBasic(m.role);

    return {
      ...m,
      disposable: m.disposable != null ? m.disposable : '-',
      monthly_limit: m.monthly_limit != null ? m.monthly_limit : '-',
      role: ROLES[m.role as keyof typeof ROLES] ?? m.role,
      status: TeamMemberStatus[rawStatus as keyof typeof TeamMemberStatus] ?? m.status,
      action: rawStatus === 'pending_approval' ? 'approve'
        : rawStatus === 'invited' || rawStatus === 'in_progress' ? 'resend'
          : rawStatus === 'enabled' && (basic || sameUser) ? 'edit' : 'view'
    };
  });
};
